export const validateExpiresAfterStartUtil = (value, allValues, translate) => {
    if (!value || !allValues?.currentKeyValidFrom) return undefined;
    return new Date(value) > new Date(allValues.currentKeyValidFrom) ? undefined : translate('resources.accessKey.validation.currentKeyExpiresAfterValidFrom');
};

export const validateNotPastDateUtil = (value, translate) => {
    if (!value) return undefined;
    const selectedDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedDate >= today ? undefined : translate('resources.accessKey.validation.dateCannotBeInPast');
};

export const validateDaysToRotateUtil = (value, allValues, translate) => {
    if (!value) return undefined;

    const { currentKeyValidFrom, currentKeyExpires } = allValues;

    if (!currentKeyValidFrom || !currentKeyExpires) return undefined;

    const validFromDate = new Date(currentKeyValidFrom);
    const expiresDate = new Date(currentKeyExpires);
    const daysToRotate = Number.parseInt(value, 10);

    const keyLifetimeInDays = Math.floor((expiresDate - validFromDate) / (1000 * 60 * 60 * 24));
    const maxAllowedDays = keyLifetimeInDays - 5;

    return daysToRotate <= maxAllowedDays ? undefined : translate('ra.validation.maxValue', { max: maxAllowedDays });
};
